export default __webpack_public_path__ + "static/media/about-us-drums-2.a0636f07.jpeg";